! function (a, b, c) {
   window[b] = c()
}(this, "bowser", function () {
   function a(a) {
      function b(b) {
         var c = a.match(b);
         return c && c.length > 1 && c[1] || ""
      }

      function c(b) {
         var c = a.match(b);
         return c && c.length > 1 && c[2] || ""
      }

      function d(a) {
         switch (a) {
            case "NT":
               return "NT";
            case "XP":
               return "XP";
            case "NT 5.0":
               return "2000";
            case "NT 5.1":
               return "XP";
            case "NT 5.2":
               return "2003";
            case "NT 6.0":
               return "Vista";
            case "NT 6.1":
               return "7";
            case "NT 6.2":
               return "8";
            case "NT 6.3":
               return "8.1";
            case "NT 10.0":
               return "10";
            default:
               return void 0
         }
      }
      var e, f = b(/(ipod|iphone|ipad)/i).toLowerCase(),
         h = /like android/i.test(a),
         i = !h && /android/i.test(a),
         j = /nexus\s*[0-6]\s*/i.test(a),
         k = !j && /nexus\s*[0-9]+/i.test(a),
         l = /CrOS/.test(a),
         m = /silk/i.test(a),
         n = /sailfish/i.test(a),
         o = /tizen/i.test(a),
         p = /(web|hpw)os/i.test(a),
         q = /windows phone/i.test(a),
         r = (/SamsungBrowser/i.test(a), !q && /windows/i.test(a)),
         s = !f && !m && /macintosh/i.test(a),
         t = !i && !n && !o && !p && /linux/i.test(a),
         u = c(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
         v = b(/version\/(\d+(\.\d+)?)/i),
         w = /tablet/i.test(a) && !/tablet pc/i.test(a),
         x = !w && /[^-]mobi/i.test(a),
         y = /xbox/i.test(a);
      /opera/i.test(a) ? e = {
         name: "Opera",
         opera: g,
         version: v || b(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      } : /opr\/|opios/i.test(a) ? e = {
         name: "Opera",
         opera: g,
         version: b(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || v
      } : /SamsungBrowser/i.test(a) ? e = {
         name: "Samsung Internet for Android",
         samsungBrowser: g,
         version: v || b(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      } : /coast/i.test(a) ? e = {
         name: "Opera Coast",
         coast: g,
         version: v || b(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      } : /yabrowser/i.test(a) ? e = {
         name: "Yandex Browser",
         yandexbrowser: g,
         version: v || b(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      } : /ucbrowser/i.test(a) ? e = {
         name: "UC Browser",
         ucbrowser: g,
         version: b(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      } : /mxios/i.test(a) ? e = {
         name: "Maxthon",
         maxthon: g,
         version: b(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      } : /epiphany/i.test(a) ? e = {
         name: "Epiphany",
         epiphany: g,
         version: b(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      } : /puffin/i.test(a) ? e = {
         name: "Puffin",
         puffin: g,
         version: b(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      } : /sleipnir/i.test(a) ? e = {
         name: "Sleipnir",
         sleipnir: g,
         version: b(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      } : /k-meleon/i.test(a) ? e = {
         name: "K-Meleon",
         kMeleon: g,
         version: b(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      } : q ? (e = {
         name: "Windows Phone",
         osname: "Windows Phone",
         windowsphone: g
      }, u ? (e.msedge = g, e.version = u) : (e.msie = g, e.version = b(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(a) ? e = {
         name: "Internet Explorer",
         msie: g,
         version: b(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      } : l ? e = {
         name: "Chrome",
         osname: "Chrome OS",
         chromeos: g,
         chromeBook: g,
         chrome: g,
         version: b(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      } : /edg([ea]|ios)/i.test(a) ? e = {
         name: "Microsoft Edge",
         msedge: g,
         version: u
      } : /vivaldi/i.test(a) ? e = {
         name: "Vivaldi",
         vivaldi: g,
         version: b(/vivaldi\/(\d+(\.\d+)?)/i) || v
      } : n ? e = {
         name: "Sailfish",
         osname: "Sailfish OS",
         sailfish: g,
         version: b(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      } : /seamonkey\//i.test(a) ? e = {
         name: "SeaMonkey",
         seamonkey: g,
         version: b(/seamonkey\/(\d+(\.\d+)?)/i)
      } : /firefox|iceweasel|fxios/i.test(a) ? (e = {
         name: "Firefox",
         firefox: g,
         version: b(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(a) && (e.firefoxos = g, e.osname = "Firefox OS")) : m ? e = {
         name: "Amazon Silk",
         silk: g,
         version: b(/silk\/(\d+(\.\d+)?)/i)
      } : /phantom/i.test(a) ? e = {
         name: "PhantomJS",
         phantom: g,
         version: b(/phantomjs\/(\d+(\.\d+)?)/i)
      } : /slimerjs/i.test(a) ? e = {
         name: "SlimerJS",
         slimer: g,
         version: b(/slimerjs\/(\d+(\.\d+)?)/i)
      } : /blackberry|\bbb\d+/i.test(a) || /rim\stablet/i.test(a) ? e = {
         name: "BlackBerry",
         osname: "BlackBerry OS",
         blackberry: g,
         version: v || b(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      } : p ? (e = {
         name: "WebOS",
         osname: "WebOS",
         webos: g,
         version: v || b(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      }, /touchpad\//i.test(a) && (e.touchpad = g)) : /bada/i.test(a) ? e = {
         name: "Bada",
         osname: "Bada",
         bada: g,
         version: b(/dolfin\/(\d+(\.\d+)?)/i)
      } : o ? e = {
         name: "Tizen",
         osname: "Tizen",
         tizen: g,
         version: b(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || v
      } : /qupzilla/i.test(a) ? e = {
         name: "QupZilla",
         qupzilla: g,
         version: b(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || v
      } : /chromium/i.test(a) ? e = {
         name: "Chromium",
         chromium: g,
         version: b(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || v
      } : /chrome|crios|crmo/i.test(a) ? e = {
         name: "Chrome",
         chrome: g,
         version: b(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      } : i ? e = {
         name: "Android",
         version: v
      } : /safari|applewebkit/i.test(a) ? (e = {
         name: "Safari",
         safari: g
      }, v && (e.version = v)) : f ? (e = {
         name: "iphone" == f ? "iPhone" : "ipad" == f ? "iPad" : "iPod"
      }, v && (e.version = v)) : e = /googlebot/i.test(a) ? {
         name: "Googlebot",
         googlebot: g,
         version: b(/googlebot\/(\d+(\.\d+))/i) || v
      } : {
            name: b(/^(.*)\/(.*) /),
            version: c(/^(.*)\/(.*) /)
         }, !e.msedge && /(apple)?webkit/i.test(a) ? (/(apple)?webkit\/537\.36/i.test(a) ? (e.name = e.name || "Blink", e.blink = g) : (e.name = e.name || "Webkit", e.webkit = g), !e.version && v && (e.version = v)) : !e.opera && /gecko\//i.test(a) && (e.name = e.name || "Gecko", e.gecko = g, e.version = e.version || b(/gecko\/(\d+(\.\d+)?)/i)), e.windowsphone || !i && !e.silk ? !e.windowsphone && f ? (e[f] = g, e.ios = g, e.osname = "iOS") : s ? (e.mac = g, e.osname = "macOS") : y ? (e.xbox = g, e.osname = "Xbox") : r ? (e.windows = g, e.osname = "Windows") : t && (e.linux = g, e.osname = "Linux") : (e.android = g, e.osname = "Android");
      var z = "";
      e.windows ? z = d(b(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : e.windowsphone ? z = b(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : e.mac ? (z = b(/Mac OS X (\d+([_\.\s]\d+)*)/i), z = z.replace(/[_\s]/g, ".")) : f ? (z = b(/os (\d+([_\s]\d+)*) like mac os x/i), z = z.replace(/[_\s]/g, ".")) : i ? z = b(/android[ \/-](\d+(\.\d+)*)/i) : e.webos ? z = b(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : e.blackberry ? z = b(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : e.bada ? z = b(/bada\/(\d+(\.\d+)*)/i) : e.tizen && (z = b(/tizen[\/\s](\d+(\.\d+)*)/i)), z && (e.osversion = z);
      var A = !e.windows && z.split(".")[0];
      return w || k || "ipad" == f || i && (3 == A || A >= 4 && !x) || e.silk ? e.tablet = g : (x || "iphone" == f || "ipod" == f || i || j || e.blackberry || e.webos || e.bada) && (e.mobile = g), e.msedge || e.msie && e.version >= 10 || e.yandexbrowser && e.version >= 15 || e.vivaldi && e.version >= 1 || e.chrome && e.version >= 20 || e.samsungBrowser && e.version >= 4 || e.firefox && e.version >= 20 || e.safari && e.version >= 6 || e.opera && e.version >= 10 || e.ios && e.osversion && e.osversion.split(".")[0] >= 6 || e.blackberry && e.version >= 10.1 || e.chromium && e.version >= 20 ? e.a = g : e.msie && e.version < 10 || e.chrome && e.version < 20 || e.firefox && e.version < 20 || e.safari && e.version < 6 || e.opera && e.version < 10 || e.ios && e.osversion && e.osversion.split(".")[0] < 6 || e.chromium && e.version < 20 ? e.c = g : e.x = g, e
   }

   function b(a) {
      return a.split(".").length
   }

   function c(a, b) {
      var c, d = [];
      if (Array.prototype.map) return Array.prototype.map.call(a, b);
      for (c = 0; c < a.length; c++) d.push(b(a[c]));
      return d
   }

   function d(a) {
      for (var d = Math.max(b(a[0]), b(a[1])), e = c(a, function (a) {
         var e = d - b(a);
         return a += new Array(e + 1).join(".0"), c(a.split("."), function (a) {
            return new Array(20 - a.length).join("0") + a
         }).reverse()
      }); --d >= 0;) {
         if (e[0][d] > e[1][d]) return 1;
         if (e[0][d] !== e[1][d]) return -1;
         if (0 === d) return 0
      }
   }

   function e(b, c, e) {
      var f = h;
      "string" == typeof c && (e = c, c = void 0), void 0 === c && (c = !1), e && (f = a(e));
      var g = "" + f.version;
      for (var i in b)
         if (b.hasOwnProperty(i) && f[i]) {
            if ("string" != typeof b[i]) throw new Error("Browser version in the minVersion map should be a string: " + i + ": " + String(b));
            return d([g, b[i]]) < 0
         } return c
   }

   function f(a, b, c) {
      return !e(a, b, c)
   }
   var g = !0,
      h = a("undefined" != typeof navigator ? navigator.userAgent || "" : "");
   return h.test = function (a) {
      for (var b = 0; b < a.length; ++b) {
         var c = a[b];
         if ("string" == typeof c && c in h) return !0
      }
      return !1
   }, h.isUnsupportedBrowser = e, h.compareVersions = d, h.check = f, h._detect = a, h.detect = a, h
}),
   function () {
      if (location.pathname.indexOf('/unsupported-browser') === 0) {
         return;
      } 

      var a = function (a) {
         var b = document.cookie.match(new RegExp("(?:^|; )" + a.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
         return b ? decodeURIComponent(b[1]) : void 0
      },
         b = a("ignore-browser");
      if (!b && bowser.isUnsupportedBrowser({
         msie: "20",
         msedge: "17",
         firefox: "52",
         chrome: "57",
         safari: "10.1",
         opera: "44"
      })) {
         var c = bowser.mobile && bowser.ios && bowser.firefox && bowser.compareVersions([bowser.version, "7.2"]) >= 0,
            d = -1 !== window.navigator.userAgent.toLowerCase().indexOf("googlebot");
         c || d || (window.location = "/unsupported-browser")
      }
   }();